<template>
  <div id="app">
    <link-list></link-list>
  </div>
</template>

<script>
import LinkList from './components/LinkList'
export default {
  name: 'app',
  components: {
    LinkList
  }
}
</script>

<style>
body {
    margin: 0;
    padding: 0;
    font-family: Verdana, Geneva, sans-serif;
}

.gray {
    color: #828282;
}

.orange {
    background-color: #ff6600;
}

.background-gray {
    background-color: rgb(246,246,239);
}

.f11 {
    font-size: 11px;
}

.w85 {
    width: 85%;
}

.button {
    font-family: monospace;
    font-size: 10pt;
    color: black;
    background-color: buttonface;
    text-align: center;
    padding: 2px 6px 3px;
    border-width: 2px;
    border-style: outset;
    border-color: buttonface;
    cursor: pointer;
    max-width: 250px;
}

#app .form-group{
    width: 100%;
}
#app .dealer_list{
    overflow: auto;
    border: 1px solid #eee;
}
#app .dealer{
    padding-top: 20px;
    cursor: pointer;
}
#app .dealer:hover{
    background: #f2f2f2;
}
#app .dealer.active{
    background: #eee;
}
#app .dealer.active hr{
    border: none
}
#app .dealer hr{
    margin-bottom:0; 
}
#app .dealer_header{
    background: #03953F;
    color: white;
    font-size: 20px;
    font-weight: 700;
    padding: 3px 5px;
    margin-bottom: 10px;
}
#app .dealer_header p{
    margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue